export const STORAGE_KEYS = {
  token: "dso_token",
  user: "dso_user",
  store: "dso_store",
  // The table's `key` (store_tables.key, e.g. "table1" — NOT its numeric id)
  // read off the QR link's ?table= param. Always overwritten whenever the app
  // loads with that param present (see SessionContext) — scanning a
  // different table's QR must immediately take over, not just be ignored in
  // favor of whatever was scanned first. Resolved against the store's
  // store_tables list to get the numeric store_tables.id placeOrder actually
  // needs — see SessionContext's `table` value.
  tableKey: "dso_table_key",
  // The QR link's ?url=<store-domain>, persisted the same way tableKey is —
  // immediately, on whichever load actually carries it — so the store can
  // still be resolved after stripSessionParamsFromUrl removes it from the
  // address bar (see SessionContext). Only ever set by a normal (cloud)
  // store's own QR/menu link — a Denzo POS's own "Tables" QR codes carry no
  // url at all (see TablesQrDialog.js/localOrigin.js), since the page's own
  // address already tells this app it's talking to a till.
  urlParam: "dso_url_param",
  // The QR link's optional ?store_id= — a Denzo POS's own "Tables" QR codes
  // carry this instead of url (see SessionContext), since a store's id never
  // changes, unlike the till's current network address, which a printed QR
  // can't follow after a router reassigns it.
  storeIdParam: "dso_store_id_param",
  // Optional — collected at checkout and reused silently afterwards so a
  // returning table guest never has to retype it, but never required to
  // place a dine_in order (see OrderController@placeOrder's contact_number
  // rule).
  contactNumber: "dso_contact_number",
  customerName: "dso_customer_name",
  // The last order this QR session placed. Kept so the Live Order screen can
  // still thank the guest (and invite a Google review) after the till has
  // closed that order and there is no live order left to show — see
  // OrderContext. Wiped with the rest of the session, which is the point: a
  // fresh scan at the same table is a different meal, probably a different
  // guest. What they answered about reviewing is remembered separately and
  // deliberately outlives this (utils/googleReview.js).
  lastOrder: "dso_last_order",
  // Session expiry bookkeeping — see enforceSessionExpiry in SessionContext.
  sessionStartedAt: "dso_session_started_at",
  lastLoadedAt: "dso_last_loaded_at",
};

// Exact status strings denzo-api's app/v1 OrderController uses. 'created' is
// the not-yet-placed cart, never shown as an order. This app only ever
// places dine_in orders (ORDER_TYPE below), and OrderController@placeOrder
// skips 'placed' entirely for dine_in — straight to 'processing', the same
// status pos/v1's own staff-finalized orders use, so it lands directly in
// Live Orders with nothing to review (see that controller's own comment).
// 'placed' is kept here anyway for take_away/delivery order types, in case
// this app (or its constants) is ever reused for those.
export const LIVE_ORDER_STATUSES = ["placed", "processing", "modifying", "dispatched"];

export { IMAGE_BASE_URL } from "./localOrigin";

// This app only ever places dine_in orders — the table comes from the QR
// code on the table itself, so there's no order-type toggle or delivery/
// takeaway flow to build here.
export const ORDER_TYPE = "dine_in";

// checkout (placeOrder) requires an offline_payment_option string even though
// this app never collects a payment method from the guest — cash matches
// denzo-waiter's own fixed default for the same field.
export const OFFLINE_PAYMENT_OPTION = "cash";

// Absolute cap on one QR scan's session, regardless of how continuously the
// guest keeps using it — a session begun at the start of a meal shouldn't
// still be live hours later.
export const SESSION_MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 hours

// If the guest closes the tab/browser and doesn't come back to this site for
// longer than this, treat the session as stale (a new customer may now be at
// that table) even though the 2-hour cap above hasn't been hit yet.
export const SESSION_RELOAD_STALE_MS = 60 * 60 * 1000; // 1 hour
